<script setup lang="ts">
import type { PropType } from 'vue';
import type { UiBadgeSizes, UiBadgeAppearances } from '@mop/ui2/types';

defineOptions({
  name: 'Ui2Badge',
});
defineProps({
  size: {
    type: String as PropType<UiBadgeSizes>,
    default: 'md',
  },
  appearance: {
    type: String as PropType<UiBadgeAppearances>,
    default: '',
  },
});
</script>

<template>
  <span :class="['ui-badge', size ? `ui-badge--${size}` : '', appearance ? `ui-badge--${appearance}` : '']">
    <slot />
  </span>
</template>

<style lang="scss">
.ui-badge {
  @include v2-text-style(sm);
  border: 1px solid currentColor;
  border-radius: $border-radius-rounded-xl;
  padding: 4px $space-12;
  display: inline-block;

  color: $color-text-body-primary;
  border-color: $color-border-secondary;
  background-color: $color-surface-primary;
}

.ui-badge--sm {
  @include v2-text-style(xs);
  padding: 2px $space-8;
}

.ui-badge--error {
  color: $color-text-error;
  border-color: $color-border-error;
  background-color: $color-surface-error;
}

.ui-badge--warning {
  color: $color-text-warning;
  border-color: $color-border-warning;
  background-color: $color-surface-warning;
}

.ui-badge--success {
  color: $color-text-success;
  border-color: $color-border-success;
  background-color: $color-surface-success;
}
</style>
